import React from "react";

import { Trans } from "react-i18next";
import { Callout } from "@blueprintjs/core";

import { authenticatedGetFetch } from "../../../../utils/AuthenticatedFetch";
import Show from "./Show";
import ShowCreator from "./ShowCreator";
import ServerSelect from "../../../Structure/ServerSelector";

export default class Shows extends React.Component {
  constructor() {
    super();
    this.state = {
      server: undefined,
      shows: [],
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.onChange();
  }

  onChange() {
    if (this.state.server !== undefined)
      authenticatedGetFetch(
        "/devices?srvfilter=" + this.state?.server?.id,
        (response) => {
          this.setState({ device_def: response }, () =>
            authenticatedGetFetch(
              "/tarif/shows?srv=" + (this.state?.server?.id || 0),
              (response) => {
                this.setState({ shows: response });
              }
            )
          );
        }
      );
  }

  render() {
    const shows = [];
    for (const show of this.state.shows)
      shows.push(
        <Show
          key={show.reference}
          {...show}
          onChange={this.onChange}
          srv={this.state?.server?.id}
          device_def={this.state.device_def}
        />
      );

    return (
      <Callout title={<Trans>show fare</Trans>}>
        <ServerSelect
          onSelect={(id, srv) =>
            this.setState({ server: srv }, () => this.onChange())
          }
        />
        <Callout intent="primary">
          <Trans>show fare description</Trans>
        </Callout>
        <div>
          {localStorage.getItem("perm_tarif") === "true" &&
            ((
              <ShowCreator
                onChange={this.onChange}
                devices_def={this.state.device_def || []}
                srv={this.state?.server?.id || 0}
              />
            ) || (
              <Callout intent="warning">
                <Trans>
                  you need administration permissions to add a new show
                </Trans>{" "}
                <Trans>
                  for any change of your permissions please contact an
                  administrator
                </Trans>
              </Callout>
            ))}
          {shows}
        </div>
      </Callout>
    );
  }
}
